import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/Admin/admin.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Router } from '@angular/router';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  constructor(private adminservice: AdminService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService,private router:Router) { }
  ChangePassModel = {
    OldPassword: '',
    NewPassword: '',
    ConfirmPassword: ''
}
SaveChangePassword() {

    if (this.ChangePassModel.NewPassword != '') {
        if (this.ChangePassModel.NewPassword == this.ChangePassModel.ConfirmPassword) {

            this.adminservice.SaveChangePassword(JSON.stringify(this.ChangePassModel)).subscribe((data: any) => {
              this.globalHelper.CheckActionStatus(data);
              this.router.navigate(['/login']);
            });
        }

        else {
                 alert('Do Not Match Confirm Password');
             }
    }
    else {
           alert('Password Can not  be blank');
         }

}
  ngOnInit() {
  }

}
